import { Typography, useMediaQuery, useTheme } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/TemplatesTable.styles'

const ContractRowSkeleton: React.FC = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <>
      <div
        className={[
          classes.tableRow,
          isSmall ? classes.tableRowSkeletonForMobile : ''
        ].join(' ')}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>

        <div />
      </div>
    </>
  )
}

export default ContractRowSkeleton
